import { bowyerWatson, Triangle } from "delaunay.js";
import Vector from "vectory-lib";

const svgNs = "http://www.w3.org/2000/svg";
let svg;
let w;
let h;

function setup() {
  svg = document.querySelector("svg");
  document.addEventListener("click", draw);
  document.addEventListener("keydown", onKeyDown);
  window.addEventListener("resize", onResize);
  onResize();
}

function onResize() {
  w = window.innerWidth;
  h = window.innerHeight;
  svg.setAttribute("viewBox", `0 0 ${w} ${h}`);
  svg.setAttribute("width", w.toString());
  svg.setAttribute("height", h);
  draw();
}

function onKeyDown (e) {
  if(e.code === "KeyD") {
    download();
  }
}

function download() {
  let svgDoc = svg.outerHTML;
  let filename = "delaunay.svg";
  let element = document.createElement("a");
  element.setAttribute("href", "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgDoc));
  element.setAttribute("download", filename);
  element.style.display = "none";
  document.body.appendChild(element);
  element.addEventListener("click", e => e.stopPropagation());
  element.click();
  element.remove();
}

function getRandomPoints() {
  let pointList = [];
  let div = Math.random() * 12000 + 4000;
  let nrOfPoints = w * h / div;
  for(let i = 0; i < nrOfPoints; i++) {
    pointList.push(new Vector(
      Math.random() * w,
      Math.random() * h
    ));
  }
  return pointList;
}

function draw() {
  let group = document.querySelector("g");
  if(group) {
    group.remove();
  }
  group = document.createElementNS(svgNs, "g");
  group.setAttribute("fill", "none");
  group.setAttribute("stroke", "black");
  group.setAttribute("stroke-linecap", "round");
  group.setAttribute("stroke-linejoin", "round");

  let pointList = getRandomPoints();

  let superTriangle = new Triangle(
    new Vector(-w * 10, h * 10),
    new Vector(w * 10, h * 10),
    new Vector(w / 2, -h * 10)
  );

  let triangles = bowyerWatson(superTriangle, pointList);
  triangles.forEach(t => drawTriangle(t, group));
  svg.appendChild(group);
}

function drawTriangle(triangle, groupElement) {
  let polygon = document.createElementNS(svgNs, "polygon");
    polygon.setAttribute("points", triangle.vertexesAsString());
    groupElement.appendChild(polygon);

    const height = triangle.shortestHeight();
    let nrOfPoints = Math.round(height * 0.25 * (Math.random() * 0.95 + 0.05));
    let points1 = getPoints(triangle.c, triangle.a, nrOfPoints);
    let points2 = getPoints(triangle.c, triangle.b, nrOfPoints);
    for(let i = 0; i < nrOfPoints; i++) {
      let line = document.createElementNS(svgNs, "line");
      line.setAttribute("x1", points1[i].x);
      line.setAttribute("y1", points1[i].y);
      line.setAttribute("x2", points2[i].x);
      line.setAttribute("y2", points2[i].y);
      groupElement.appendChild(line);
    }
  }

function getPoints(p1, p2, nrOfPoints) {
  let points = [];
  let delta = p1.sub(p2).div(nrOfPoints+1);
  for(let i = 1; i < nrOfPoints+1; i++) {
    let currentPos = p2.add(delta.mult(i));
    points.push(currentPos);
  }
  return points;
}

setup();
